import React, { useEffect } from "react"
import { Input } from "reactstrap"

export const SearchFilter = ({ search, setSearch }) => {
    const textSearch = JSON.parse(localStorage.getItem("searchText"))

    useEffect(() => {
        setSearch(textSearch);
    }, [textSearch, window.location.href])
    // if(textSearch){
    //     setSearch(textSearch);
    // }
    return (
        <span>
            <Input
                id="searchFilter"
                className="w-100 input-color rounded-pill"
                type="text"
                placeholder="ค้นหา"
                value={search || ""}
                onChange={e => {
                    localStorage.setItem("searchText", JSON.stringify(e.target.value))
                    setSearch(e.target.value)
                }}>
            </Input>

        </span>

    )
}